// extracted by mini-css-extract-plugin
export default {"alertbody":"DeleteAlert_alertbody__iygCu","delete_ok_btn":"DeleteAlert_delete_ok_btn__3eRQS","delete_cancel_btn":"DeleteAlert_delete_cancel_btn__6N5CG"};